import React from "react";
import { Route, Redirect } from "react-router-dom";

function ProtectedRoute({ ...rest }) {
    const isAuthenticated = localStorage.getItem('authToken');
    return isAuthenticated ? <Route {...rest} /> : <Redirect to="/" />
};

export default ProtectedRoute;